// Brand colors from espy-dashboard src/theme/searchTokens.ts (the part
// result-v2 uses), copied so the admin copy doesn't depend on the dashboard.
export const brand = {
  primary: '#2D89F4',
  primaryDark: '#1B6FD6',
  primaryDarker: '#1559B0',
  ink: '#0B081D',
  navy: '#181542',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  violet: '#7C5CFF',
}
